import MuiModal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';

export const StyledModal = styled(MuiModal)({}) as typeof MuiModal;
